// lib/services/mapas.ts
import { connection } from '@/lib/connection'
import { apiUrl } from '@/lib/config'
import type { Mapping } from '@/types/mapping'

const API_URL = apiUrl('/mapas')
const ts = () => `_ts=${Date.now()}`

export type GuardarMapaDTO = {
  nombre: string
  svg: string            // SVG como string
  mapping: Mapping | any // tu objeto final (puede ser el que armamos desde mappingRef + store)
}

export type MapaListItem = {
  id: string;
  nombre: string;
  svg?: string;
  mapping_json?: any;
  createdAt?: string;
};


export async function guardarMapaJSON(dto: GuardarMapaDTO, cookies?: string) {
  const url = `${API_URL}?${ts()}`
  return await connection<any>(url, 'POST', {}, dto, cookies)
}

const slug = (s: string) =>
  s.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-_]/g, '')

export async function guardarMapaMultipart(dto: GuardarMapaDTO, cookies?: string) {
  const fd = new FormData()
  fd.append('nombre', dto.nombre)

  const svgFile = new Blob([dto.svg], { type: 'image/svg+xml' })
  fd.append('svg', svgFile, `${slug(dto.nombre) || 'mapa'}.svg`)

  const mappingFile = new Blob([JSON.stringify(dto.mapping)], { type: 'application/json' })
  fd.append('mapping', mappingFile, 'mapping.json')

  const res = await fetch(`${API_URL}?${ts()}`, {
    method: 'POST',
    body: fd,
    headers: cookies ? { cookie: cookies } : undefined,
  })
  if (!res.ok) throw new Error(await res.text())
  return await res.json()
}


export async function getMapas(cookies?: string): Promise<MapaListItem[]> {
  const url = `${API_URL}?${ts()}`;
  const data = await connection<any>(url, 'GET', {}, null, cookies);
  if (Array.isArray(data)) return data as MapaListItem[];
  return Array.isArray(data?.mapas) ? data.mapas : [];
}

export async function getMapaById(id: string, cookies?: string): Promise<MapaListItem | null> {
  const url = `${API_URL}/${id}?${ts()}`;
  const data = await connection<any>(url, 'GET', {}, null, cookies);
  if (data?.mapa && typeof data.mapa === 'object') return data.mapa as MapaListItem;
  if (data && typeof data === 'object') return data as MapaListItem;
  return null;
}

// ── Tipado opcional del resumen ────────────────────────────────────────────────
export type MapaResumen = {
  mapaId: string;
  total: number;
  tipos: Array<{
    tipoEntradaId: string;
    nombre: string;
    color?: string;
    cantidad: number;
  }>;
};

// ── GET /mapas/:id/resumen ────────────────────────────────────────────────────
export async function getMapaResumen(id: string, cookies?: string): Promise<MapaResumen> {
  const url = `${API_URL}/${id}/resumen?${ts()}`;
  return await connection<any>(url, 'GET', {}, null, cookies);
}
